import React, { isValidElement, cloneElement } from 'react';

type ReactChildArray = ReturnType<typeof React.Children.toArray>;

function flattenReactChildren(children: React.ReactNode, keys: Array<string | number> = []): ReactChildArray {
    const childrenArray = React.Children.toArray(children);
    const result: ReactChildArray = [];

    for (let index = 0; index < childrenArray.length; index++) {
        const child = childrenArray[index];

        if (isFragment(child)) {
            const childElement = child as React.ReactElement;
            const nestedChildren = childElement.props.children;

            result.push(...flattenReactChildren(nestedChildren, keys.concat(childElement.key ?? index)));
        } else if (isValidElement(child)) {
            const clonedNode = cloneElement(child, {
                key: keys.concat(String(child.key)).join('.'),
            });

            result.push(clonedNode);
        } else if (isPrimitive(child)) {
            result.push(child);
        }
    }

    return result;
}

export { flattenReactChildren };

// Helpers

const isFragment = (node: unknown) => (node as React.ReactElement<unknown>).type === React.Fragment;
const isPrimitive = (node: unknown) => typeof node === 'string' || typeof node === 'number';
